/**
 * Terms of Use Page
 */

import { PolicyPage } from './PolicyPage';

const termsOfUseContent = `FLOWRITHM – TERMS OF USE (FULL LEGAL DRAFT — 2026)
Owned and Operated by Lagori AI LLP
Last Updated: [Insert Date]

1. INTRODUCTION
Welcome to FlowRithm, an AI-powered multi-broker trading, analytics, and strategy automation platform provided by Lagori AI LLP, a limited liability partnership registered in India ("Company", "we", "us", "our").

By accessing or using FlowRithm, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree, you must discontinue using the Platform immediately.

2. ACCEPTANCE OF TERMS
You agree to these Terms by:
• Creating an account
• Accessing the platform
• Connecting your broker
• Using any feature (AI assistant, backtesting, portfolio analytics, order execution, etc.)

3. ELIGIBILITY
FlowRithm may be used only by:
• Individuals 18 years or older
• Entities legally capable of entering contracts
• Advisors/RIAs holding valid SEBI registrations (where applicable)
• Institutional clients bound by enterprise agreements

4. NATURE OF FLOWRITHM PLATFORM
FlowRithm is a technology platform offering tools for:
• Multi-broker integration
• Market data visualization
• AI-powered strategy assistance
• Algorithmic backtesting and simulations
• Portfolio analytics
• Real-time insights
• Risk analytics

FlowRithm IS NOT:
• A SEBI-registered broker
• A SEBI-registered investment advisor (RIA)
• A portfolio manager
• A mutual fund distributor
• A custodian of user funds or securities

5. ACCOUNT REGISTRATION & SECURITY
To use FlowRithm, you must:
• Create an account using your email and/or phone
• Authenticate using OTP, password, or SSO
• Provide accurate and updated information

You are responsible for securing your login credentials and maintaining device-level security.

6. USER RESPONSIBILITIES
By using FlowRithm, you agree to:
• Use the Platform only for lawful purposes
• Provide accurate information
• Not misuse, hack, reverse-engineer, or disrupt the Platform
• Not attempt unauthorized automation of orders
• Comply with applicable SEBI guidelines
• Maintain full responsibility for your trading decisions

7. MULTI-BROKER INTEGRATIONS
FlowRithm integrates with various SEBI-regulated brokers via OAuth-based APIs.

By linking your broker, you authorize FlowRithm to:
• Access your trading data (orders, trades, positions, holdings)
• Place orders only when explicitly triggered by you
• Provide portfolio analytics

We DO NOT:
• Store your broker passwords
• Initiate trades without your confirmation
• Guarantee the accuracy or stability of broker APIs

8. ORDERS, EXECUTION & TRADING LIMITATIONS
FlowRithm offers order routing tools but is not responsible for:
• Execution quality
• Price slippage
• Latency
• Market movement
• Partial fills
• Rejections due to broker/exchange rules

IMPORTANT: FlowRithm does NOT provide guaranteed execution, and DOES NOT execute trades autonomously unless you explicitly confirm each trade.

9. MARKET DATA, ACCURACY & DELAYS
Market data (prices, quotes, charts, analytics) may be delayed, incomplete, or inaccurate due to third-party data provider issues, API throttling, network congestion, or exchange outages.

FlowRithm does not guarantee data accuracy or availability.

10. STRATEGIES, BACKTESTING & USER-GENERATED CONTENT
All strategies created by users remain the intellectual property of the user.

Users agree that:
• Backtests are simulations, not predictions
• Historical results do NOT guarantee future performance
• You are fully responsible for deploying any strategy

11. AI TOOLS DISCLAIMER
FlowRithm includes AI features such as natural language trading, strategy enhancement suggestions, and behavioral analytics.

CRITICAL WARNING:
• AI outputs do NOT constitute investment advice
• AI does NOT guarantee profitability
• AI does NOT replace professional judgment
• Users remain fully responsible for their decisions

12. PROHIBITED USES
You agree not to:
• Reverse engineer, copy, scrape, clone, or reproduce any part of the Platform
• Use FlowRithm for market manipulation
• Use bots, HFT systems, or unauthorized automated execution
• Mine or harvest broker-provided real-time data
• Share or resell analytics, signals, or proprietary FlowRithm insights

13. PAYMENT, SUBSCRIPTIONS, BILLING, AND REFUND POLICY
FlowRithm offers subscription-based paid plans. All prices are subject to applicable GST.

Refund Policy:
FlowRithm follows a strict non-refundable policy, except where required by Indian law. Refunds are not issued for partial usage, change of mind, dissatisfaction with AI insights, strategy performance issues, or broker failures.

14. INTELLECTUAL PROPERTY
All FlowRithm components are owned by Lagori AI LLP, including UI/UX, logos, trademarks, backend microservices, strategy engine, API specifications, AI models, and documentation.

15. LIMITATION OF LIABILITY
To the maximum extent permitted by law, we are not liable for trading losses, broker failure, delays, outages, AI errors, data delays, or indirect damages.

Total liability is limited to the amount paid by you in the last 12 months.

16. GOVERNING LAW
These Terms are governed by the laws of India. Disputes shall be resolved through binding arbitration under the Arbitration and Conciliation Act, 1996.

17. CONTACT INFORMATION
For legal, billing, or support queries:
Lagori AI LLP
Email: contact@flowrithm.trade
Privacy Queries: contact@flowrithm.trade`;

export function TermsOfUsePage() {
  return <PolicyPage title="Terms of Use" content={termsOfUseContent} />;
}
